import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';

import {
  CardElement,
  injectStripe,
} from 'react-stripe-elements';

import {
  Button,
  Form,
  Segment
} from 'semantic-ui-react';
import FieldTemplate from '../../ui/semantic-form/field-template';

import { graphql } from 'react-apollo';
import CreateStripeCard from '../../../graphql/mutations/create-stripe-card.graphql';
import UserQuery from '../../../graphql/queries/user.graphql';

@graphql(CreateStripeCard, { name: 'createStripeCard' })
@graphql(UserQuery, { name: 'user' })
@injectStripe
@withRouter
export default class CardForm extends Component {
  render() {
    if (this.props.user.loading) {
      return null;
    }

    return (
      <Form onSubmit={this._onSubmit}>
        <Segment>
          <FieldTemplate required displayLabel label="Credit Card">
            <CardElement />
          </FieldTemplate>
        </Segment>
        <Button primary>Submit</Button>
      </Form>
    );
  }

  _onSubmit = () => {
    const { user } = this.props.user;

    this.props.stripe
      .createToken()
      .then(({ token }) => {
        const variables = {
          token: token.id,
          brand: token.card.brand,
          expMonth: token.card.exp_month,
          expYear: token.card.exp_year,
          last4: token.card.last4,
          stripeCardId: token.card.id,
          userId: user.id
        };

        this.props
          .createStripeCard({ variables })
          .then((response) => {
            this.props.history.replace('/');
          });
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/container/payment-form/card-form.js